import { Component, computed, inject, input, signal } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UserInfoService } from '../../../features/user/services/user-info.service';
import { Button } from 'excellence-ui';
import { HttpError } from '../../../core/clients/omni-core/models';
import { ErrorComponent } from '../error-component/error-component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-youtube-embed',
  imports: [Button, ErrorComponent, TranslocoPipe],
  templateUrl: './youtube-embed.html',
})
export class YoutubeEmbed {
  private domSanitizer = inject(DomSanitizer);
  private userInfoService = inject(UserInfoService);

  url = input.required<string>();

  protected safeResourceUrl = computed(() =>
    this.domSanitizer.bypassSecurityTrustResourceUrl(this.url()),
  );

  protected allowYoutube = this.userInfoService.allowYoutube;

  protected activateYoutubeLoading = signal(false);
  protected activateYoutubeError = signal<HttpError | unknown | null>(null);

  protected async onClickActivateYoutube() {
    this.activateYoutubeLoading.set(true);
    this.activateYoutubeError.set(null);
    try {
      await this.userInfoService.setAllowYoutube(true);
    } catch (error) {
      this.activateYoutubeError.set(error);
    } finally {
      this.activateYoutubeLoading.set(false);
    }
  }
}
